import { VehicleCompanyOutputWithStatus } from './vehicle-company-output-with-status.model';


export class VehicleCompanySelectByIdOutput implements IVehicleCompanySelectByIdOutput {
    status!: number;
    message!: string;
    data!: VehicleCompanyOutputWithStatus;

    constructor(data?: IVehicleCompanySelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? VehicleCompanyOutputWithStatus.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VehicleCompanySelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleCompanySelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IVehicleCompanySelectByIdOutput {
    status: number;
    message: string;
    data: VehicleCompanyOutputWithStatus;
}

